import { withTranslation } from 'react-i18next';
import FormUserProfilePassword from '../../components/Forms/FormUserProfile/FormUserProfilePassword';

export default withTranslation()(FormUserProfilePassword);
